import * as React from 'react';
import {
  Getter, Action, Plugin, createStateHelper,
} from '@devexpress/dx-react-core';
import { toggleSelection } from '@devexpress/dx-grid-core';
import PropTypes from 'prop-types'

class SelectionStateBase extends React.PureComponent {
  static defaultProps = {
    defaultSelection: [],
  };
  toggleSelection;

  constructor(props) {
    super(props);

    this.state = {
      selection: props.selection || props.defaultSelection,
      data: props.data
    };

    const stateHelper = createStateHelper(
      this,
      {
        selection: () => {
          const { onSelectionChange } = this.props;
          return onSelectionChange;
        },
      },
    );

    this.toggleSelection = stateHelper.applyFieldReducer
      .bind(stateHelper, 'selection', toggleSelection);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let {
      selection = prevState.selection,
      data,
      onSelectionChange
    } = nextProps;

    if (!Object.is(prevState.data, data)) {
      selection = []
      onSelectionChange?.(selection)
    }

    return {
      selection,
      data
    };
  }

  render() {
    const { selection } = this.state;

    return (
      <Plugin
        name="SelectionState"
      >
        <Getter name="selection" value={selection} />
        <Action name="toggleSelection" action={this.toggleSelection} />
      </Plugin>
    );
  }
}

SelectionStateBase.propTypes = {
  selection: PropTypes.any,
  defaultSelection: PropTypes.any,
  onSelectionChange: PropTypes.func,
  data: PropTypes.array
}
/** A plugin that manages the selection state. */
export const SelectionState = SelectionStateBase;